<template>
  <b-overlay
    :show="loader"
    opacity="0.50"
    rounded="sm"
  >
    <div class="container">

      <!-- Formulario -->
      <validation-observer ref="formularioCostos">

        <b-form class="px-2">
          <b-row>
            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="12"
            >
              <validation-provider
                v-slot="{ errors, validate }"
                name="Concepto"
                rules="required"
              >
                <selectTipoAportacion
                  :disabled="modoEdicion"
                  :conceptop="dataToSave.concepto"
                  @selectedtipo="val => {
                    dataToSave.concepto = val
                    validate(val)
                  }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <!-- Field: Aportacion -->
            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="12"
            >
              <label for="nombre">Aportacion <b class="text-danger">*</b></label>
              <validation-provider
                #default="{ errors }"
                name="aportacion"
                rules="required"
              >
                <b-skeleton-wrapper :loading="loader || updateStatus">
                  <template #loading>
                    <b-skeleton
                      class="mb-75"
                      type="button"
                      width="100%"
                    />
                  </template>
                  <div class="mb-75">
                    <b-form-input
                      id="nombre"
                      v-model="dataToSave.monto"
                      :disabled="modoEdicion"
                      :state="errors.length ? false : null"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </b-skeleton-wrapper>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <!-- Fecha Inicio -->
            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="12"
            >
              <label for="cct">Inicio <b class="text-danger">*</b></label>
              <validation-provider
                ref="inicioProvider"
                v-slot="{ errors, validate }"
                name="fecha Inicio"
                :rules="`required|fechainicio:${dataToSave.fecha_fin}`"
              >
                <b-skeleton-wrapper :loading="loader || updateStatus">
                  <template #loading>
                    <b-skeleton
                      type="button"
                      width="100%"
                      class="mb-75"
                    />
                  </template>
                  <calendario
                    :disabled="modoEdicion"
                    color="primary"
                    :fecha="fia"
                    @fechacalendario="val => {
                      dataToSave.fecha_inicio = val
                      validate(val)
                    }"
                  />
                </b-skeleton-wrapper>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <!-- Fecha Fin  -->
            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="12"
            >
              <label for="cct">Fin <b class="text-danger">*</b></label>
              <validation-provider
                ref="finProvider"
                v-slot="{ errors, validate }"
                name="fecha fin"
                :rules="`required|fechafin:${dataToSave.fecha_inicio}`"
              >
                <b-skeleton-wrapper :loading="loader || updateStatus">
                  <template #loading>
                    <b-skeleton
                      type="button"
                      width="100%"
                      class="mb-75"
                    />
                  </template>
                  <calendario
                    color="warning"
                    :fecha="ffa"
                    @fechacalendario="val => {
                      dataToSave.fecha_fin = val
                      validate(val)
                    }"
                  />
                </b-skeleton-wrapper>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row
            class="mt-1"
          >
            <!-- Field: Comentarios -->
            <b-col
              cols="12"
              lg="9"
              md="9"
              sm="12"
            >
              <label for="nombre">Comentarios</label>
              <validation-provider
                #default="{ errors }"
                name="comentarios"
              >
                <b-skeleton-wrapper :loading="loader || updateStatus">
                  <template #loading>
                    <b-skeleton
                      class="mb-75"
                      type="button"
                      width="100%"
                    />
                  </template>
                  <div class="mb-75">
                    <b-form-textarea
                      id="textarea-default"
                      v-model="dataToSave.comentarios"
                      placeholder="Comentarios adicionales"
                      rows="3"
                    />
                  </div>
                </b-skeleton-wrapper>

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <!-- Field: Orden -->
            <b-col
              cols="12"
              lg="3"
              md="3"
              sm="12"
            >
              <label for="nombre">Orden <b class="text-danger">*</b></label>
              <validation-provider
                #default="{ errors }"
                name="orden"
                rules="required"
              >
                <b-skeleton-wrapper :loading="loader || updateStatus">
                  <template #loading>
                    <b-skeleton
                      class="mb-75"
                      type="button"
                      width="100%"
                    />
                  </template>
                  <div class="mb-75">
                    <b-form-input
                      id="nombre"
                      v-model="dataToSave.orden"
                      :state="errors.length ? false : null"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </b-skeleton-wrapper>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row class="mt-2 justify-content-end">
            <b-button
              size="sm"
              class="mr-1"
              variant="outline-secondary"
              @click="cerrar()"
            >
              <b>Cerrar</b>
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="validationForm()"
            >
              <b>Guardar</b>
            </b-button>
          </b-row>

        </b-form>

      </validation-observer>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCol,
  BForm,
  BFormInput,
  BRow,
  BSkeleton,
  BSkeletonWrapper,
  BFormTextarea,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
import { formhttp } from '@core/utils/utils'
import { required } from '@validations'
import { ref, watch, getCurrentInstance } from '@vue/composition-api'
import { rolesActions } from '@core/mixins/account-data/roles'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { useToast } from 'vue-toastification/composition'
import calendario from '@/views/components/seleccionar-fecha.vue'
import selectTipoAportacion from '@/views/campus/costos/TipoAportacion.vue'
import { postData } from '@core/utils/http/general'
import store from '@/store'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BForm,
    BSkeletonWrapper,
    BSkeleton,
    ValidationProvider,
    ValidationObserver,
    calendario,
    BFormTextarea,
    selectTipoAportacion,
    BButton,
    BOverlay,
  },
  directives: {
    'height-fade': heightFade,
  },
  mixins: [rolesActions],
  props: {
    aportacion: {
      type: Object,
      default: null,
    },
    modoEdicion: {
      type: Boolean,
      default: false,
    },
    idplan: {
      type: Number,
      required: true,
    },
  },
  // eslint-disable-next-line no-unused-vars
  setup(props, { emit }) {
    const toast = useToast()
    const formularioCostos = ref(null)
    const loader = ref(false)
    const fia = ref(null)
    const ffa = ref(null)
    const dataToSave = ref({
      id: null,
      monto: null,
      fecha_inicio: null,
      fecha_fin: null,
      concepto: null,
      orden: null,
      comentarios: null,
    })
    const updateStatus = ref(false)
    const vm = getCurrentInstance().proxy

    const inicioProvider = ref(null)
    const finProvider = ref(null)

    const cerrar = () => {
      vm.$bvModal.hide('modal-costos')
    }

    const sendData = () => {
      loader.value = true
      const data = new FormData()
      data.append('task', 'wsplanEstudios')
      data.append('origin', process.env.VUE_APP_ORIGIN_API)
      data.append('token', store.state.cuenta.session.token)
      const action = props.modoEdicion ? 14 : 15
      data.append('action', action)
      data.append('id', JSON.stringify(dataToSave.value.id))
      data.append('fecha_fin', JSON.stringify(dataToSave.value.fecha_fin))
      data.append('comentarios', JSON.stringify(dataToSave.value.comentarios))
      data.append('orden', JSON.stringify(dataToSave.value.orden))

      // creacion se mandan todos los campos, en edicion solo los editables
      if (!props.modoEdicion) {
        data.append('fecha_inicio', JSON.stringify(dataToSave.value.fecha_inicio))
        data.append('monto', JSON.stringify(dataToSave.value.monto))
        data.append('concepto', JSON.stringify(dataToSave.value.concepto?.id))
        data.append('idplan', JSON.stringify(props.idplan))
      }
      postData(data)
        .then(response => {
          const { icon, label } = formhttp(response.data.status)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Respuesta de solicitud',
              text: response.data.message,
              icon,
              variant: label,
            },
          },
          { timeout: 8000 })

          if (response.status === 200 && response.data.status === 200) {
            emit('guardado')
            cerrar()
          }
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error al editar aportación',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
        })
        .finally(() => {
          loader.value = false
        })
    }

    // * Validación de formulario antes de POST
    const validationForm = () => {
      formularioCostos.value.validate().then(success => {
        if (success) sendData()
        else {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Información de solicitud',
              text: 'Revise que los datos estén completos',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 8000 })
        }
      })
    }

    const resetForm = () => {
      dataToSave.value = {
        id: null,
        monto: null,
        fecha_inicio: null,
        fecha_fin: null,
        comentarios: null,
        concepto: null,
        orden: null,
      }
    }

    // Dentro del watch de props.aportacion en ModalForm.vue
    watch(() => props.aportacion,
      value => {
        if (value && props.modoEdicion) {
          dataToSave.value = {
            id: value.id,
            monto: value.monto,
            fecha_inicio: value.fecha_inicio,
            fecha_fin: value.fecha_fin,
            comentarios: value.comentarios,
            concepto: value.concepto,
            orden: value.orden,
          }
          fia.value = value.fecha_inicio
          ffa.value = value.fecha_fin

          // Esperamos a que Vue actualice el DOM y luego validamos manualmente
          vm.$nextTick(() => {
            if (formularioCostos.value) {
              formularioCostos.value.validate()
            }
          })
        } else {
          resetForm()
          // Si es nuevo, limpiamos errores
          vm.$nextTick(() => {
            if (formularioCostos.value) {
              formularioCostos.value.reset()
            }
          })
        }
      },
      { immediate: true })

    watch(
      () => [dataToSave.value.fecha_inicio, dataToSave.value.fecha_fin],
      async () => {
        await vm.$nextTick()
        if (inicioProvider.value) inicioProvider.value.validate()

        if (finProvider.value) finProvider.value.validate()
      },
    )

    return {
      // Variables
      dataToSave,
      fia,
      ffa,
      validationForm,
      updateStatus,
      loader,
      // Filters
      required,
      cerrar,
      // Refs
      formularioCostos,
      finProvider,
      inicioProvider,
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style scoped>
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
